import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Website} from '../website';
import {RouteUrlHistoryService} from '../../../shared/services/route-url-history/route-url-history.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {filter, first, switchMap} from 'rxjs/operators';
import {RouteData} from '../../../shared/services/route-data/route-data';
import {RouteDataService} from '../../../shared/services/route-data/route-data.service';

@Component({
    selector: 'db-change-environment',
    templateUrl: './change-environment.component.html',
    styleUrls: ['./change-environment.component.scss'],
    standalone: false
})
export class ChangeEnvironmentComponent implements OnInit {

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _routeDataService: RouteDataService,
    private _store: Store<fromStore.DbStoreState>,
    private _routeUrlSegmentsHistoryService: RouteUrlHistoryService
  ) {}

  ngOnInit(): void {
    const websiteId: number = this._route.snapshot.parent.parent.data['website'].id;
    const previousRouteUrl: string = this._routeUrlSegmentsHistoryService.getPreviousRouteUrl();
    const urlParts: string[] = previousRouteUrl ? previousRouteUrl.split('/') : null;
    const websitesPartIndex: number = urlParts ? urlParts.indexOf('websites') : -1;
    const baseUrl: string = this._router.url.split('?')[0];
    const isLive: boolean = baseUrl.split('/').reverse()[0] === 'live';
    const isNetwork: boolean = baseUrl.split('/').reverse()[0] === 'network';
    this._store.select(fromStore.getWebsitesLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getWebsite(websiteId))),
        first()
      )
      .subscribe((website: Website) => {
        if (!website || websitesPartIndex === -1 || !urlParts) {
          this._router.navigate(['/websites']);
          return;
        }

        urlParts.splice(websitesPartIndex + 1, 1, isNetwork ? website.id : ( isLive ? website.siblingId.dev : website.siblingId.live));
        const previousRouteData: RouteData = this._routeDataService.getPreviousRouteData();
        if (previousRouteData && ['hosting-domains-manage-dns', 'restore', 'manage-environment'].includes(previousRouteData.pageId)) {
          urlParts[4] = "info";
          urlParts.splice(5, 1);
        }
        const page: string = this._route.snapshot.queryParams['manageEnv'] === 'true' ? '/hosting/manage-environment' : '/main';
        const url: string = urlParts[1] + '/' + urlParts[2] + page;
        this._router.navigateByUrl(url);
      });
  }

}
